import React from 'react';
import {
  Box,
  Chip,
  Stack,
  Typography,
  Tooltip,
} from '@mui/material';
import {
  Devices as DevicesIcon,
  LocationOff as EmptyIcon,
  NewReleases as NewIcon,
  Update as RecentIcon,
  FilterList as FilterIcon,
} from '@mui/icons-material';
import { useIsMobile } from '../../hooks/useResponsive';

/**
 * Quick Filters Component
 * Provides one-click preset filters for common search scenarios
 */
const QuickFilters = ({ onFilterClick, activeFilters = [] }) => {
  const isMobile = useIsMobile();
  const filters = [
    {
      id: 'has-devices',
      label: 'Has Devices',
      icon: <DevicesIcon fontSize="small" />,
      filter: 'devices:>0',
      color: 'primary',
    },
    {
      id: 'empty',
      label: 'Empty',
      icon: <EmptyIcon fontSize="small" />,
      filter: 'devices:=0',
      color: 'default',
    },
    {
      id: 'rooms',
      label: 'Rooms Only',
      icon: <FilterIcon fontSize="small" />,
      filter: 'type:room',
      color: 'secondary',
    },
    {
      id: 'buildings',
      label: 'Buildings',
      icon: <FilterIcon fontSize="small" />,
      filter: 'type:building',
      color: 'info',
    },
  ];

  const isActive = (filterId) => activeFilters.includes(filterId);

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" gutterBottom sx={{ display: 'block', mb: 1 }}>
        Quick Filters
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
        {filters.map(filter => (
          <Tooltip
            key={filter.id}
            title={`Filter: ${filter.filter}`}
            disableHoverListener={isMobile}
            disableTouchListener={false}
          >
            <Chip
              icon={filter.icon}
              label={filter.label}
              size={isMobile ? "medium" : "small"}
              color={isActive(filter.id) ? filter.color : 'default'}
              variant={isActive(filter.id) ? 'filled' : 'outlined'}
              onClick={() => onFilterClick(filter)}
              clickable
              sx={{
                minHeight: { xs: 36, sm: 32 },
                '& .MuiChip-icon': {
                  fontSize: { xs: '1.25rem', sm: '1rem' }
                },
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 1,
                  transition: 'all 0.2s ease'
                },
                '&:active': {
                  transform: 'translateY(0)',
                },
                transition: 'all 0.2s ease',
                fontWeight: isActive(filter.id) ? 600 : 400
              }}
            />
          </Tooltip>
        ))}
      </Stack>
    </Box>
  );
};

export default QuickFilters;
